import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { fetchSubscriptions } from 'api/team-api';
import { useSession } from 'components/Authenticated';
import { Spin } from 'antd';
import AzurePlans from './AzurePlans';
import StripePlans from './StripePlans';
const CreditInfo = ({ totalCredit, payAsYouGoCredit, onRefetchCredit, }) => {
    const { session } = useSession();
    const [subscriptions, setSubscriptions] = useState('loading');
    const getSubscriptions = async () => {
        const subs = await fetchSubscriptions(session.connection);
        if (subs.isSuccess()) {
            setSubscriptions(subs.get().list);
        }
    };
    useEffect(() => {
        void getSubscriptions();
    }, []);
    if (subscriptions === 'loading') {
        return _jsx(Spin, {});
    }
    return (subscriptions[0].sourceSystem === 'AzureMarketplace' ? (_jsx(AzurePlans, { subscriptions: subscriptions, onRefetchSubscriptions: getSubscriptions, totalCredit: totalCredit, onRefetchCredit: onRefetchCredit })) : (_jsx(StripePlans, { subscriptions: subscriptions, totalCredit: totalCredit, payAsYouGoCredit: payAsYouGoCredit })));
};
export default CreditInfo;
